// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"274":"69e2e8fd","298":"581a4baa","347":"2d97f998","626":"140f1db2"}[chunkId] + ".js";
};